export default function PromoModal() {
  return (
    <div className="modal fade mt-5" id="promo-modal" tabIndex={-1} role="dialog" aria-labelledby="promo-modal-label" aria-hidden="true">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header text-center">
            <div id="promo-modal-label" className="w-100">Promo Offers</div>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <>
              <div style={{fontSize: 40}}>🍀</div>
              <p>Players with the 🍀 ("four-leaf clover") icon mean they are a limited time promo offer.</p>
            </>
          </div>
        </div>
      </div>
    </div>
  )

}